import { LicenseServiceInterface, License, SingleResponse, APIClientInterface, AvailableLicense } from '../types'

export default class LicenseService implements LicenseServiceInterface {
	constructor(private client: APIClientInterface) {}

	public get(customerId: number): Promise<SingleResponse<License[]>> {
		return this.client.get(`/endcustomers/${customerId}/licenses`)
	}

	public add(customerId: number, id: number, quantity: number): Promise<SingleResponse<License>> {
		return this.client.post(`/endcustomers/${customerId}/licenses`, JSON.stringify({ license_id: id, quantity }))
	}

	public update(customerId: number, serial: string, quantity: number): Promise<SingleResponse<License>> {
		return this.client.patch(`/endcustomers/${customerId}/licenses/${serial}`, JSON.stringify({ quantity }))
	}

	public async getAvailable(customerId: number): Promise<SingleResponse<AvailableLicense[]>> {
		return this.client.get(`/endcustomers/${customerId}/availablelicenses`)
	}
}
